






























import { defineComponent, ref } from "@vue/composition-api";
import { isEqual } from "lodash-es";
import { Group, GroupParticipant, InputGroupMembersUpdate } from "@scrile/api-provider/dist/api/GroupsProvider";
import { useGroups } from "@/hooks/useGroups";
import useOnChangePage from "@/hooks/useOnChangePage";
import providers from "@/lib/api";
import AddNewGroup from "@/components/AddNewGroup";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseSpinner from "@/components/BaseSpinner";
import GroupList from "@/components/GroupList";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "GroupModal",
  components: { BaseSpinner, ModalView, GroupList, BaseCheckbox, BaseButton, AddNewGroup },
  props: {
    userId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    useOnChangePage(() => emit("close"));
    const { getMyGroups, getUserGroupsInfo, groups } = useGroups({ system: false });

    const checkedGroups = ref<Record<string, boolean>>({});
    const initialCheckedGroups = ref<Record<string, boolean>>({});
    const anyChanges = ref(false);
    const saving = ref(false);
    const userParticipants = ref<GroupParticipant[]>([]);

    const getUserData = async () => {
      userParticipants.value = await getUserGroupsInfo(props.userId, ["userId", "groupId"]);
      const checked = userParticipants.value.reduce(
        (acc, participant) => {
          acc[participant.groupId] = true;
          return acc;
        },
        {} as Record<string, boolean>
      );

      const groupsMapped = groups.value.reduce(
        (acc, group) => {
          acc[group.id] = false;
          return acc;
        },
        {} as Record<string, boolean>
      );

      checkedGroups.value = { ...groupsMapped, ...checked };

      initialCheckedGroups.value = { ...checkedGroups.value };
    };

    const checkboxChange = (value: boolean, id: string) => {
      checkedGroups.value = { ...checkedGroups.value, [id]: value };
      anyChanges.value = !isEqual(initialCheckedGroups.value, checkedGroups.value);
    };

    const onCreateGroup = (group: Group) => {
      groups.value.push(group);
    };

    const onSave = async () => {
      const selectedGroups: InputGroupMembersUpdate[] = [];
      for (const id in checkedGroups.value) {
        selectedGroups.push({
          id,
          memberId: props.userId,
          status: checkedGroups.value[id],
        });
      }
      try {
        saving.value = true;
        await providers.GroupsProvider.updateMembers({ data: selectedGroups });
        anyChanges.value = false;
        emit("close");
      } finally {
        saving.value = false;
      }
    };

    const getData = async () => {
      try {
        loading.value = true;
        await getMyGroups();
        await getUserData();
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      groups,
      checkedGroups,
      saving,
      anyChanges,
      onCreateGroup,
      checkboxChange,
      onSave,
    };
  },
});
